var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g3, _path15, _g4, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 119,
    viewBox: "0 0 122 119",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.508 105.421C85.2972 105.421 106.203 84.5154 106.203 58.7264C106.203 32.9374 85.2972 12.0312 59.508 12.0312C33.7188 12.0312 12.8125 32.9374 12.8125 58.7264C12.8125 84.5154 33.7188 105.421 59.508 105.421Z",
    fill: "url(#paint0_linear_11341_284627)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7017 22.8984H32.9729C29.7486 22.8984 27.1348 25.5122 27.1348 28.7365H90.5398C90.5398 25.5122 87.926 22.8984 84.7017 22.8984Z",
    fill: "url(#paint1_linear_11341_284627)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1348 28.5742H90.5398V76.8642C90.5398 79.0112 89.6869 81.0703 88.1688 82.5884C86.6506 84.1066 84.5915 84.9595 82.4445 84.9595H35.2301C33.0831 84.9595 31.024 84.1066 29.5058 82.5884C27.9877 81.0703 27.1348 79.0112 27.1348 76.8642V28.5742Z",
    fill: "url(#paint2_linear_11341_284627)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 34.6758H38.0545C37.1884 34.6758 36.4863 35.3771 36.4863 36.2422C36.4863 37.1074 37.1884 37.8087 38.0545 37.8087H79.6412C80.5072 37.8087 81.2093 37.1074 81.2093 36.2422C81.2093 35.3771 80.5072 34.6758 79.6412 34.6758Z",
    fill: "url(#paint3_linear_11341_284627)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 47.9883H38.0545C37.1884 47.9883 36.4863 48.6896 36.4863 49.5547C36.4863 50.4199 37.1884 51.1212 38.0545 51.1212H79.6412C80.5072 51.1212 81.2093 50.4199 81.2093 49.5547C81.2093 48.6896 80.5072 47.9883 79.6412 47.9883Z",
    fill: "url(#paint4_linear_11341_284627)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 61.2969H38.0545C37.1884 61.2969 36.4863 61.9982 36.4863 62.8633C36.4863 63.7284 37.1884 64.4298 38.0545 64.4298H79.6412C80.5072 64.4298 81.2093 63.7284 81.2093 62.8633C81.2093 61.9982 80.5072 61.2969 79.6412 61.2969Z",
    fill: "url(#paint5_linear_11341_284627)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6412 74.6094H38.0545C37.1884 74.6094 36.4863 75.3107 36.4863 76.1758C36.4863 77.0409 37.1884 77.7423 38.0545 77.7423H79.6412C80.5072 77.7423 81.2093 77.0409 81.2093 76.1758C81.2093 75.3107 80.5072 74.6094 79.6412 74.6094Z",
    fill: "url(#paint6_linear_11341_284627)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11341_284627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7723 58.4453H15.6275C13.8485 58.4453 12.4062 59.8875 12.4062 61.6665V93.3187C12.4062 95.0977 13.8485 96.5399 15.6275 96.5399H37.7723C39.5514 96.5399 40.9936 95.0977 40.9936 93.3187V61.6665C40.9936 59.8875 39.5514 58.4453 37.7723 58.4453Z",
    fill: "url(#paint7_linear_11341_284627)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_11341_284627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.811 9H76.3509C75.2111 9 74.2871 9.92397 74.2871 11.0638V22.5604C74.2871 23.7001 75.2111 24.6241 76.3509 24.6241H100.811C101.95 24.6241 102.874 23.7001 102.874 22.5604V11.0638C102.874 9.92397 101.95 9 100.811 9Z",
    fill: "url(#paint8_linear_11341_284627)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3003 74.2734H18.0977C17.5184 74.2734 17.0488 74.743 17.0488 75.3223V75.3257C17.0488 75.9049 17.5184 76.3745 18.0977 76.3745H35.3003C35.8796 76.3745 36.3492 75.9049 36.3492 75.3257V75.3223C36.3492 74.743 35.8796 74.2734 35.3003 74.2734Z",
    fill: "url(#paint9_linear_11341_284627)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3114 89.0547H18.2566C17.6824 89.0547 17.2168 89.5096 17.2168 90.0708V90.0741C17.2168 90.6353 17.6824 91.0903 18.2566 91.0903H35.3114C35.8857 91.0903 36.3513 90.6353 36.3513 90.0741V90.0708C36.3513 89.5096 35.8857 89.0547 35.3114 89.0547Z",
    fill: "url(#paint10_linear_11341_284627)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3114 81.3242H18.2566C17.6824 81.3242 17.2168 81.7792 17.2168 82.3404V82.3436C17.2168 82.9048 17.6824 83.3598 18.2566 83.3598H35.3114C35.8857 83.3598 36.3513 82.9048 36.3513 82.3436V82.3404C36.3513 81.7792 35.8857 81.3242 35.3114 81.3242Z",
    fill: "url(#paint11_linear_11341_284627)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.389 63.3281H19.362C18.2484 63.3281 17.3457 64.2308 17.3457 65.3444V66.7394C17.3457 67.853 18.2484 68.7557 19.362 68.7557H24.389C25.5025 68.7557 26.4053 67.853 26.4053 66.7394V65.3444C26.4053 64.2308 25.5025 63.3281 24.389 63.3281Z",
    fill: "url(#paint12_linear_11341_284627)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3219 19.1789C81.6323 19.1789 82.6945 18.1166 82.6945 16.8062C82.6945 15.4959 81.6323 14.4336 80.3219 14.4336C79.0115 14.4336 77.9492 15.4959 77.9492 16.8062C77.9492 18.1166 79.0115 19.1789 80.3219 19.1789Z",
    fill: "#1589EE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8004 19.1789C90.1108 19.1789 91.173 18.1166 91.173 16.8062C91.173 15.4959 90.1108 14.4336 88.8004 14.4336C87.49 14.4336 86.4277 15.4959 86.4277 16.8062C86.4277 18.1166 87.49 19.1789 88.8004 19.1789Z",
    fill: "#1589EE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2809 19.1789C98.5912 19.1789 99.6535 18.1166 99.6535 16.8062C99.6535 15.4959 98.5912 14.4336 97.2809 14.4336C95.9705 14.4336 94.9082 15.4959 94.9082 16.8062C94.9082 18.1166 95.9705 19.1789 97.2809 19.1789Z",
    fill: "#1589EE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.847 75.7698L84.8379 82.3945L101.776 97.7581L107.785 91.1334L90.847 75.7698Z",
    fill: "url(#paint13_linear_11341_284627)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1975 64.8124C97.1975 78.6713 85.9626 89.9061 72.1036 89.9061C58.2447 89.9061 47.0098 78.6713 47.0098 64.8124C47.0098 50.9536 58.2447 39.7188 72.1036 39.7188C85.9626 39.7188 97.1975 50.9536 97.1975 64.8124ZM93.3489 64.811C93.3489 76.5441 83.8373 86.0556 72.1041 86.0556C60.371 86.0556 50.8593 76.5441 50.8593 64.811C50.8593 53.0779 60.371 43.5664 72.1041 43.5664C83.8373 43.5664 93.3489 53.0779 93.3489 64.811Z",
    fill: "url(#paint14_linear_11341_284627)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_11341_284627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.1041 86.0517C83.8373 86.0517 93.3489 76.5402 93.3489 64.8071C93.3489 53.074 83.8373 43.5625 72.1041 43.5625C60.371 43.5625 50.8594 53.074 50.8594 64.8071C50.8594 76.5402 60.371 86.0517 72.1041 86.0517Z",
    fill: "url(#paint15_linear_11341_284627)",
    fillOpacity: 0.2
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2096 64.8102L83.2855 58.7208C83.8548 58.1183 84.1666 57.3177 84.1549 56.489C84.1432 55.6603 83.8087 54.8688 83.2227 54.2827C82.6366 53.6967 81.8451 53.3623 81.0164 53.3505C80.1877 53.3388 79.3871 53.6507 78.7846 54.2199L72.6951 60.3093L66.6192 54.2199C66.3269 53.9104 65.9754 53.6628 65.5857 53.4916C65.1959 53.3203 64.7758 53.229 64.3501 53.223C63.9244 53.2169 63.5019 53.2963 63.1074 53.4565C62.713 53.6166 62.3547 53.8542 62.0536 54.1552C61.7526 54.4562 61.515 54.8145 61.3549 55.209C61.1948 55.6034 61.1154 56.026 61.1214 56.4516C61.1274 56.8773 61.2188 57.2974 61.39 57.6872C61.5612 58.0769 61.8089 58.4284 62.1183 58.7208L68.2044 64.8102L62.1183 70.8996C61.8089 71.192 61.5612 71.5435 61.39 71.9332C61.2188 72.323 61.1274 72.7431 61.1214 73.1687C61.1154 73.5944 61.1948 74.017 61.3549 74.4114C61.515 74.8058 61.7526 75.1642 62.0536 75.4652C62.3547 75.7662 62.713 76.0038 63.1074 76.1639C63.5019 76.3241 63.9244 76.4034 64.3501 76.3974C64.7758 76.3914 65.1959 76.3001 65.5857 76.1288C65.9754 75.9576 66.3269 75.7099 66.6192 75.4005L72.7087 69.3111L78.7982 75.4005C79.4063 75.9362 80.1958 76.2197 81.0058 76.1935C81.8158 76.1672 82.5853 75.8331 83.1574 75.2592C83.7296 74.6853 84.0614 73.9148 84.0852 73.1048C84.109 72.2948 83.823 71.5061 83.2855 70.8996L77.2096 64.8102Z",
    fill: "url(#paint16_linear_11341_284627)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_11341_284627)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.5419,
    cy: 76.5423,
    rx: 14.87,
    ry: 2.20632,
    fill: "#EC5575",
    fillOpacity: 0.56
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7423 93.7579C55.107 92.2405 57.2655 92.2405 57.6302 93.7579C57.7604 94.2996 58.1833 94.723 58.7247 94.8543C60.2439 95.2226 60.2439 97.3846 58.7247 97.753C58.1833 97.8842 57.7604 98.3076 57.6302 98.8493C57.2655 100.367 55.107 100.367 54.7423 98.8493C54.6121 98.3076 54.1893 97.8842 53.6478 97.753C52.1286 97.3846 52.1286 95.2226 53.6478 94.8543C54.1893 94.723 54.6121 94.2996 54.7423 93.7579Z",
    fill: "url(#paint17_linear_11341_284627)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0978 15.5978C21.4625 14.0804 23.621 14.0804 23.9857 15.5978C24.1159 16.1395 24.5387 16.5628 25.0802 16.6941C26.5994 17.0624 26.5994 19.2245 25.0802 19.5928C24.5387 19.7241 24.1159 20.1474 23.9857 20.6891C23.621 22.2065 21.4625 22.2065 21.0978 20.6891C20.9676 20.1474 20.5447 19.7241 20.0033 19.5928C18.4841 19.2245 18.4841 17.0624 20.0033 16.6941C20.5447 16.5628 20.9676 16.1395 21.0978 15.5978Z",
    fill: "url(#paint18_linear_11341_284627)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4488 13.5102C58.2327 13.5102 58.8682 12.872 58.8682 12.0846C58.8682 11.2973 58.2327 10.659 57.4488 10.659C56.6649 10.659 56.0294 11.2973 56.0294 12.0846C56.0294 12.872 56.6649 13.5102 57.4488 13.5102ZM57.4488 14.5794C58.8206 14.5794 59.9327 13.4625 59.9327 12.0846C59.9327 10.7068 58.8206 9.58984 57.4488 9.58984C56.0769 9.58984 54.9648 10.7068 54.9648 12.0846C54.9648 13.4625 56.0769 14.5794 57.4488 14.5794Z",
    fill: "url(#paint19_linear_11341_284627)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.027 54.5145C101.695 53.2056 102.898 52.0261 104.193 52.3915L104.284 52.4172C105.578 52.7826 105.994 54.4186 105.031 55.3621L104.964 55.4282C104.001 56.3716 102.383 55.915 102.051 54.6062L102.027 54.5145Z",
    fill: "url(#paint20_linear_11341_284627)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6283 47.0859C17.9318 46.7539 19.1043 47.9636 18.7388 49.2635L18.7132 49.3546C18.3477 50.6545 16.7181 51.0697 15.78 50.1019L15.7143 50.0341C14.7762 49.0662 15.2333 47.4412 16.5369 47.1092L16.6283 47.0859Z",
    fill: "url(#paint21_linear_11341_284627)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3158 96.3437C85.6193 96.0117 86.7918 97.2214 86.4263 98.5213L86.4007 98.6124C86.0352 99.9124 84.4056 100.328 83.4675 99.3597L83.4018 99.2919C82.4637 98.324 82.9208 96.6991 84.2244 96.367L84.3158 96.3437Z",
    fill: "url(#paint22_linear_11341_284627)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.873 34.272C105.657 34.272 106.292 33.6337 106.292 32.8464C106.292 32.059 105.657 31.4208 104.873 31.4208C104.089 31.4208 103.453 32.059 103.453 32.8464C103.453 33.6337 104.089 34.272 104.873 34.272ZM104.873 35.3412C106.244 35.3412 107.357 34.2242 107.357 32.8464C107.357 31.4685 106.244 30.3516 104.873 30.3516C103.501 30.3516 102.389 31.4685 102.389 32.8464C102.389 34.2242 103.501 35.3412 104.873 35.3412Z",
    fill: "url(#paint23_linear_11341_284627)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M101.773 97.7578L107.783 91.1331L108.688 91.954C109.566 92.7506 110.092 93.8633 110.149 95.0475C110.207 96.2318 109.792 97.3904 108.995 98.2685C108.199 99.1467 107.086 99.6725 105.902 99.7302C104.718 99.7879 103.559 99.3728 102.681 98.5763L101.776 97.7553L101.773 97.7578Z",
    fill: "#1589EE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11341_284627",
    x: 0.40625,
    y: 50.4453,
    width: 58.5879,
    height: 68.0938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11341_284627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11341_284627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11341_284627",
    x: 67.2871,
    y: 0,
    width: 54.5879,
    height: 41.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11341_284627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11341_284627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_11341_284627",
    x: 34.1842,
    y: 26.8874,
    width: 75.8405,
    height: 75.8386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.33757
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_11341_284627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_11341_284627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_11341_284627",
    x: 36.8279,
    y: 53.492,
    width: 71.4281,
    height: 46.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.422,
    result: "effect1_foregroundBlur_11341_284627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11341_284627",
    x1: 59.148,
    y1: -3.17383,
    x2: 60.1046,
    y2: 160.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AC4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11341_284627",
    x1: 27.063,
    y1: 24.2458,
    x2: 90.5715,
    y2: 28.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11341_284627",
    x1: 25.231,
    y1: 70.8563,
    x2: 116.83,
    y2: 72.4847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AC4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11341_284627",
    x1: 34.5948,
    y1: 37.6795,
    x2: 83.8547,
    y2: 37.6795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1589EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11341_284627",
    x1: 34.5948,
    y1: 50.992,
    x2: 83.8547,
    y2: 50.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1589EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11341_284627",
    x1: 34.5948,
    y1: 64.3006,
    x2: 83.8547,
    y2: 64.3006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1589EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11341_284627",
    x1: 34.5948,
    y1: 77.6131,
    x2: 83.8547,
    y2: 77.6131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1589EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11341_284627",
    x1: 11.5479,
    y1: 87.0116,
    x2: 66.3403,
    y2: 91.5118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AC4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11341_284627",
    x1: 73.4288,
    y1: 20.7162,
    x2: 114.706,
    y2: 21.9102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AC4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11341_284627",
    x1: 38.589,
    y1: 76.4372,
    x2: 15.3834,
    y2: 76.4372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11341_284627",
    x1: 38.5719,
    y1: 91.1509,
    x2: 15.5657,
    y2: 91.1509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_11341_284627",
    x1: 38.5719,
    y1: 83.4205,
    x2: 15.5657,
    y2: 83.4205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_11341_284627",
    x1: 32.6873,
    y1: 68.7034,
    x2: 16.1991,
    y2: 68.7034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.243799,
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_11341_284627",
    x1: 88.7401,
    y1: 85.9477,
    x2: 94.8058,
    y2: 79.2945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_11341_284627",
    x1: 46.9529,
    y1: 51.3013,
    x2: 97.4704,
    y2: 51.6293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_11341_284627",
    x1: 72.1041,
    y1: 43.5625,
    x2: 93.5116,
    y2: 99.1129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_11341_284627",
    x1: 61.2312,
    y1: 54.7819,
    x2: 84.3006,
    y2: 76.3352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF698D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E91548"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_11341_284627",
    x1: 47.6506,
    y1: 91.6981,
    x2: 64.7953,
    y2: 91.8089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_11341_284627",
    x1: 14.0061,
    y1: 13.5379,
    x2: 31.1507,
    y2: 13.6488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_11341_284627",
    x1: 54.9592,
    y1: 10.7414,
    x2: 59.9597,
    y2: 10.7737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_11341_284627",
    x1: 99.8785,
    y1: 55.2415,
    x2: 105.045,
    y2: 50.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_11341_284627",
    x1: 15.9067,
    y1: 44.9268,
    x2: 20.8789,
    y2: 50.0788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_11341_284627",
    x1: 83.5942,
    y1: 94.1847,
    x2: 88.5664,
    y2: 99.3366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_11341_284627",
    x1: 102.383,
    y1: 31.5031,
    x2: 107.384,
    y2: 31.5354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1589EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.4299f825b4622491872418318de873ce.svg";
export { ForwardRef as ReactComponent };